// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3qiRI","rootSuccess":"CompleteLink_rootSuccess__ZCb7A","rootFailure":"CompleteLink_rootFailure__1c9Gv","isDisabled":"CompleteLink_isDisabled__1c-Bo"};